<template>
    <div>
      <section id="sdgs" class="sdgs section">
          <div class="container section-title">
              <h1>{{ titleSdgs }}</h1>
          </div>
          
          <div class="container">
              <div class="row justify-content-center g-4">
                <div class="col-lg-12 col-md-6" data-aos="fade-up" data-aos-delay="100" v-for="data in dataSdgs" :key="data.id">
                    <div class="sdgs-item d-flex align-items-center">
                        <div class="d-flex align-items-start">
                            <i :class="data.icon" style="font-size: 70px; margin-right: 15px;"></i>
                            <div class="text-start">
                                <h5 class="card-title mb-2" >{{ data.name }}</h5>
                                <p class="card-text">{{ data.description }}</p>
                            </div>
                        </div>
                        <div class="mt-3">
                            <img class="img-sdgs" :src="gambarUrl + data.sdgs" :alt="data.sdgs">
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </section>
    </div>
</template>
<script>
import FasilitasJs from './js/app.js';
export default FasilitasJs;
</script>

